<template>
  <div>
    <!-- Data Stores Hack, need to be loaded first -->
    <POSStore ref="posStore"/>
    <!-- ///////////////////////////////////////// -->

    <h1>POS Summary - Moneris</h1>
    <p>ℹ️ Info: This report summarizes the transactional data from Moneris.</p>
    <GenericDatePeriodSelector storeName="posStore" dateKey="Week" :willLoadData="true"/>
    <GenericDaysSelector storeName="posStore" />

    <POSTransactionSettlementToggler storeName="posStore" />

    <button @click="isPivotView=!isPivotView">Toggle</button>
    
    <ExportToExcel 
      :tables="['RCGB', 'RMGB', 'WGB', 'RMGB_FULL']" 
      bookName="POS Report"
      storeName="posStore"
    />

    <POSTable storeName="posStore" location="RCGB" :isPivotView="isPivotView"/>
    <div class="pagebreak"> </div>
    <POSTable storeName="posStore" location="RMGB" :isPivotView="isPivotView"/>
    <div class="pagebreak"> </div>
    <POSTable storeName="posStore" location="WGB" :isPivotView="isPivotView"/>
    <div class="pagebreak"> </div>
    <POSTable storeName="posStore" location="RMGB_FULL" :isPivotView="isPivotView"/>
  </div>
</template>

<script>
import POSStore from '@/pages/Reports/POS/Stores/POSStore.vue'
import POSTable from '@/pages/Reports/POS/Components/POSTable.vue'
import POSTransactionSettlementToggler from '@/pages/Reports/POS/Components/POSTransactionSettlementToggler.vue'

export default {
  name: 'POSSummaryReport',
  components:{ POSTable, POSTransactionSettlementToggler, POSStore},
  provide(){
    return {
      posPage: this,
      page: this,
    }
  },
    data(){
    return {
      isPivotView:false,
    }
  },
  computed:{
    timestamps(){return this.$refs.posStore.timestamps},
  },
  methods:{
  }
}
</script>